module.exports = __webpack_public_path__ + "img/Paladin.f13c79ab.png";